import { render } from "./terms.vue?vue&type=template&id=64675f5b&scoped=true"
import script from "./terms.vue?vue&type=script&lang=js"
export * from "./terms.vue?vue&type=script&lang=js"

import "./terms.vue?vue&type=style&index=0&id=64675f5b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64675f5b"]])

export default __exports__